import { CoreIcon } from '../core-icon';
import carbeautyFillSVG from '../../assets/icons/carbeauty-fill.svg';
import type { IconProps } from '../core-icon';

export const CarbeautyFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={carbeautyFillSVG} {...props} />;
};
